export const ROUTES = {
  HOME: '/',
  SEARCH: '/search',
  REPORTS: '/reports',
  REPORT: '/report/:name',
  CONSULTATION: '/consultation/:id',
  DETAILS: '/consultation/:id/details',
  RESPONSE: '/consultation/:id/response',
  ARCHIVEDRESPONSE: '/consultation/:id/response/:responseId',
  MEASURE: '/consultation/:id/measure/:path',
  MONITOR: '/monitor',
  MANAGETEAM: '/manageteam',
  MANAGEADMINUSERS: '/manageadminusers',
  MANAGECONSULTEES: '/manageconsultees',
  CREATEORGANISATION: '/create_organisation',
  EDITORGANISATION: '/organisations/:id',
  EDITORGANISATIONPATH: '/organisations/:id/:path?',
  UNAUTHORISED: '/unauthorised',
  PAGENOTFOUND: '/page-not-found',
};
